module.exports = __webpack_public_path__ + "static/react-logo-937067b72183179a1d3a318c84707be9.svg";